import { useEffect, useState, useRef } from "react";
import { Form, Row, InputGroup } from "react-bootstrap";
import SectionRow from "../PantallasEdit/SectionRow/SectionRow";
import EditSection from "../PantallasEdit/EditSection/EditSection";
import InputContainer from "../PantallasEdit/InputContainer/InputContainer";
import { AnimatedIconButton } from "../AnimatedIconButton/AnimatedIconButton";
import { BarrioLookup } from "../Lookups/DivisionTerritorialLookups/BarrioLookup";
import { MunicipioLookup } from "../Lookups/DivisionTerritorialLookups/MunicipioLookup";
import { ProvinciaLookup } from "../Lookups/DivisionTerritorialLookups/ProvinciaLookup";
import { SubBarrioLookup } from "../Lookups/DivisionTerritorialLookups/SubBarrioLookup";
import { PAIS } from "../../Utils";
import Select from "react-select"
export const DivisionTerritorialSection = ({
                                               initialValue,
                                               onChange = () => {},
                                               SectionLabel = "Dirección",
                                               hideAddress = false,
                                               showDireccion = false,
                                               showMap = false,
                                               style,
                                               mt,
                                               mb,
                                                posicionCanvas
                                           }) => {
    const [selectedValues, setSelectedValues] = useState({
        DireccionCalle: "",
        DireccionNumero: "",
        DireccionProvincia: 0,
        DireccionMunicipio: 0,
        DireccionBarrio: 0,
        DireccionSubBarrio: 0,
        Latitud: "",
        Longitud: "",
        DireccionLinea1: "",
        DireccionLinea2: "",
        Pais: ""
    });
    const [isClicked, setIsClicked] = useState(true);
    const [direccionChanged, setDireccionChanged] = useState(false);
    const [copied, setCopied] = useState(false);
    const municipioRef = useRef();
    const barrioRef = useRef();
    const subBarrioRef = useRef();
    const provinciaRef = useRef();

    useEffect(() => {
        const objStr1 = JSON.stringify(initialValue);
        const objStr2 = JSON.stringify(selectedValues);
        if (objStr1 !== objStr2) {
            setSelectedValues({
                ...selectedValues,
                ...initialValue,
            });
        }
    }, [initialValue]);

    const handlePaisChange = (e) => {
        if(!e.value) e.value = e.Id;
        if (e.value != "" && e.value !== selectedValues.DireccionPais) {
            setIsClicked(false);
            setSelectedValues((prev) => {
                const newValue = {
                    ...prev,
                    DireccionPais: e.value,
                    DireccionPaisNombre: e.label,
                    DireccionMunicipio: null,
                    DireccionBarrio: null,
                    DireccionSubBarrio: null,
                    DireccionMunicipioNombre: "",
                    DireccionBarrioNombre: "",
                    DireccionSubBarrioNombre: "",
                };

                onChange(newValue);
                return newValue;
            });
            provinciaRef.current?.clearSelection();
            municipioRef.current?.clearSelection();
            barrioRef.current?.clearSelection();
            subBarrioRef.current?.clearSelection();
            setDireccionChanged((p) => !p);
        } else {
            setSelectedValues({
                ...selectedValues,
                DireccionPais: e.value,
                DireccionPaisNombre: e.label,
            });
        }
    };
    
    const handleProvinciaChange = (e) => {
        if(!e.value) e.value = e.Id;
        if (e.value > 0 && e.value !== selectedValues.DireccionProvincia) {
            setIsClicked(false);
            setSelectedValues((prev) => {
                const newValue = {
                    ...prev,
                    DireccionProvincia: e.value,
                    DireccionProvinciaNombre: e.label,
                    DireccionMunicipio: null,
                    DireccionBarrio: null,
                    DireccionSubBarrio: null,
                    DireccionMunicipioNombre: "",
                    DireccionBarrioNombre: "",
                    DireccionSubBarrioNombre: "",
                };

                onChange(newValue);
                return newValue;
            });

            municipioRef.current?.clearSelection();
            barrioRef.current?.clearSelection();
            subBarrioRef.current?.clearSelection();
            setDireccionChanged((p) => !p);
        } else {
            setSelectedValues({
                ...selectedValues,
                DireccionProvincia: e.value,
                DireccionProvinciaNombre: e.label,
            });
        }
    };

    const handleMunicipioChange = (e) => {
        if(!e.value) e.value = e.Id;
        if (e.value > 0 && e.value !== selectedValues.DireccionMunicipio) {
            setIsClicked(false);
            setSelectedValues((prev) => {
                const newValue = {
                    ...prev,
                    DireccionMunicipio: e.value,
                    DireccionMunicipioNombre: e.label,
                    DireccionBarrio: null,
                    DireccionSubBarrio: null,
                    DireccionBarrioNombre: "",
                    DireccionSubBarrioNombre: "",
                };

                onChange(newValue);
                return newValue;
            });

            barrioRef.current?.clearSelection();
            subBarrioRef.current?.clearSelection();

            setDireccionChanged((p) => !p);
        } else {
            setSelectedValues({
                ...selectedValues,
                DireccionMunicipio: e.value,
                DireccionMunicipioNombre: e.label,
            });
        }
    };

    const handleBarrioChange = (e) => {
        if(!e.value) e.value = e.Id;
        if (e.value > 0 && e.value !== selectedValues.DireccionBarrio) {
            setIsClicked(false);
            setSelectedValues((prev) => {
                const newValue = {
                    ...prev,
                    DireccionBarrio: e.value,
                    DireccionBarrioNombre: e.label,
                    DireccionSubBarrio: null,
                    DireccionSubBarrioNombre: "",
                };

                onChange(newValue);
                return newValue;
            });

            subBarrioRef.current?.clearSelection();
            setDireccionChanged((p) => !p);
        } else {
            setSelectedValues({
                ...selectedValues,
                DireccionBarrio: e.value,
                DireccionBarrioNombre: e.label,
            });
        }
    };

    const handleSubBarrioChange = (e) => {
        if(!e.value) e.value = e.Id;
        if (e.value > 0 && e.value !== selectedValues.DireccionSubBarrio) {
            setIsClicked(false);
            setSelectedValues((prev) => {
                const newValue = {
                    ...prev,
                    DireccionSubBarrio: e.value,
                    DireccionSubBarrioNombre: e.label,
                };
                onChange(newValue);
                return newValue;
            });
            setDireccionChanged((p) => !p);
        } else {
            setSelectedValues({
                ...selectedValues,
                DireccionSubBarrio: e.value,
                DireccionSubBarrioNombre: e.label,
            });
        }
    };

    const handleDireccionCalleChange = (e) => {
        setSelectedValues((prev) => {
            const newValue = {
                ...prev,
                DireccionCalle: e.target.value,
            };
            onChange(newValue);
            return newValue;
        });
    };

    const handleLatLonChange = (e) => {
        setSelectedValues((prev) => {
            const newValue = {
                ...prev,
                Longitud: e?.lng,
                Latitud: e?.lat,
            };
            onChange(newValue);
            return newValue;
        });
    };

    const handleCopy = () => {
        const inputValue = document.getElementById("latitudLongitud")?.value ?? "";
        navigator.clipboard.writeText(inputValue);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 3000);
    };

    return (
        <EditSection title={SectionLabel} style={style} mt={mt} mb={mb}>
            {showDireccion && (
                <>
                    <Row
                        style={{
                            marginBottom: "0.50rem",
                            display: "flex",
                            flexDirection: "column",
                            padding: "0px 5% 0px 20px",
                        }}
                    >
                        <InputContainer colSize="12">
                            <Form.Control
                                name="DireccionLinea1"
                                type="text"
                                placeholder="Calle, Numero, Apartamento, Código Postal"
                                value={selectedValues.DireccionLinea1 ?? ""}
                                onChange={(e) => {
                                    setSelectedValues((prev) => {
                                        const newValue = {
                                            ...prev,
                                            DireccionLinea1: e.target.value,
                                        };
                                        onChange(newValue);
                                        return newValue;
                                    });
                                }}
                            />
                        </InputContainer>
                        <InputContainer colSize="12">
                            <Form.Control
                                name="DireccionLinea2"
                                placeholder="Referencia"
                                type="text"
                                value={selectedValues.DireccionLinea2 ?? ""}
                                onChange={(e) => {
                                    setSelectedValues((prev) => {
                                        const newValue = {
                                            ...prev,
                                            DireccionLinea2: e.target.value,
                                        };
                                        onChange(newValue);
                                        return newValue;
                                    });
                                }}
                            />
                        </InputContainer>
                    </Row>
                </>
            )}
            {!hideAddress && (
                <SectionRow style={{ marginBottom: "0.50rem" }}>
                    <InputContainer label="Calle">
                        <Form.Control
                            name="DireccionCalle"
                            type="text"
                            value={selectedValues.DireccionCalle ?? ""}
                            onChange={(e) => {
                                handleDireccionCalleChange(e);
                            }}
                        />
                    </InputContainer>
                    <InputContainer label="Número">
                        <Form.Control
                            name="DireccionNumero"
                            type="text"
                            value={selectedValues.DireccionNumero ?? ""}
                            onChange={(e) => {
                                setSelectedValues((prev) => {
                                    const newValue = {
                                        ...prev,
                                        DireccionNumero: e.target.value,
                                    };
                                    onChange(newValue);
                                    return newValue;
                                });
                            }}
                        />
                    </InputContainer>
                </SectionRow>
            )}
            <SectionRow>
                <InputContainer label="Pais">
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="Pais"
                        onChange={(e) => {
                            handlePaisChange(e);
                        }}
                        isDisabled={true}
                        options={PAIS}
                        value={PAIS.filter(function (option) {
                            return option.value === initialValue.DireccionPais;
                        })}

                    />
                </InputContainer>
            </SectionRow>
            <SectionRow>
                <InputContainer label="Provincia">
                    <ProvinciaLookup
                        placement={posicionCanvas}
                        initialValue={{
                            value: selectedValues.DireccionProvincia,
                            label: selectedValues.DireccionProvinciaNombre,
                        }}
                        onChange={(e) => {
                            handleProvinciaChange(e);
                        }}
                        ref={provinciaRef}

                    />
                </InputContainer>
                <InputContainer label="Barrio">
                    <BarrioLookup
                        placement={posicionCanvas}
                        initialValue={{
                            value: selectedValues.DireccionBarrio,
                            label: selectedValues.DireccionBarrioNombre,
                        }}
                        onChange={(e) => {
                            handleBarrioChange(e);
                        }}
                        municipioId={selectedValues.DireccionMunicipio}
                        ref={barrioRef}
                    />
                </InputContainer>
            </SectionRow>
            <SectionRow>
                <InputContainer label="Municipio">
                    <MunicipioLookup
                        placement={posicionCanvas}
                        initialValue={{
                            value: selectedValues.DireccionMunicipio,
                            label: selectedValues.DireccionMunicipioNombre,
                        }}
                        onChange={(e) => {
                            handleMunicipioChange(e);
                        }}
                        provinciaId={selectedValues.DireccionProvincia}
                        ref={municipioRef}
                    />
                </InputContainer>
                <InputContainer label="Sub-Barrio">
                    <SubBarrioLookup
                        placement={posicionCanvas}
                        initialValue={{
                            value: selectedValues.DireccionSubBarrio,
                            label: selectedValues.DireccionSubBarrioNombre,
                        }}
                        onChange={(e) => {
                            handleSubBarrioChange(e);
                        }}
                        barrioId={selectedValues.DireccionBarrio}
                        ref={subBarrioRef}
                    />
                </InputContainer>
            </SectionRow>
        </EditSection>
    );
};
